import React, { useEffect, useRef } from 'react';

// Dokładna lokalizacja kancelarii – ul. Bracka 20/7a, Warszawa
const OFFICE_LAT = 52.232153;
const OFFICE_LNG = 21.017233;

const OFFICE_ADDRESS_HTML = `
  <strong>Pieńkowski – Kancelaria Adwokacka</strong><br/>
  ul. Bracka 20/7a<br/>
  00-028 Warszawa
`;

type ContactMapProps = {
  height?: number;
  offset?: number;
  width?: number;
};

export const ContactMap: React.FC<ContactMapProps> = ({ height, offset, width }) => {
  const mapContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const container = mapContainerRef.current;

    if (!container || typeof L === 'undefined') {
      return;
    }

    const map = L.map(container, {
      scrollWheelZoom: false,
      zoomControl: true,
    }).setView([OFFICE_LAT, OFFICE_LNG], 17);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);

    if (map.attributionControl && typeof map.attributionControl.setPrefix === 'function') {
      map.attributionControl.setPrefix('Leaflet');
    }

    const icon = L.divIcon({
      className: 'contact-map__marker',
      html: '',
      iconSize: [28, 28],
      iconAnchor: [14, 26],
    });

    const marker = L.marker([OFFICE_LAT, OFFICE_LNG], { icon }).addTo(map);

    marker
      .bindPopup(OFFICE_ADDRESS_HTML, {
        closeButton: false,
        offset: [0, -10],
      })
      .openPopup();

    marker.on('click', () => {
      marker.openPopup();
    });

    return () => {
      map.remove();
    };
  }, []);

  return (
    <section className="contact-map" aria-label="Mapa dojazdu do kancelarii">
      <div
        id="contact-map-canvas"
        ref={mapContainerRef}
        className="contact-map__canvas"
        style={{
          height: height ? `${height}px` : undefined,
          marginTop: offset ? `-${offset}px` : undefined,
          width: width ? `${width}px` : undefined,
          maxWidth: width ? '100%' : undefined,
        }}
      />
    </section>
  );
};
